import './BalancePanel.scss';
import { memo, type PropsWithChildren, type SyntheticEvent } from 'react';

import { CLICK_IDS } from '@sunflower-games/analytics-events';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import { PlusIcon } from '../BalancePlusIcon/PlusIcon';

import { BalancePlusContext } from './BalancePlusContext';
import { useShowDualBalance } from './useShowDualBalance';

export const BalancePanel = memo(
  observer(function BalancePanel(
    props: PropsWithChildren & {
      handleClick: (clickId: string) => void;
    },
  ) {
    const showDualBalance = useShowDualBalance();

    const onPress = (clickId: string) => {
      return (ev: SyntheticEvent<HTMLElement>) => {
        ev.stopPropagation();
        props.handleClick(clickId);
      };
    };

    return (
      <BalancePlusContext.Provider value={onPress}>
        <div
          className={classNames('balance-panel', { 'balance-panel--dual': showDualBalance })}
          id="gc_balance"
          onClick={onPress(CLICK_IDS.PURCHASE.HEADER_BALANCE_WRAPPER)}
        >
          {props.children}
          {/* In dual-balance mode the "+" lives inside the SC pill, rendered by <Balance>. */}
          {!showDualBalance && (
            <div className="balance-panel-right">
              <PlusIcon onPress={onPress} />
            </div>
          )}
        </div>
      </BalancePlusContext.Provider>
    );
  }),
);
